import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Modal, Spin } from "antd";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Icons from "scripts/icons";
import Resources from "scripts/resources";

const Component = ({ ladderDescription }) => {
	const initialState = { phoneNumbers: [] };
	const [state, setState] = useState(initialState);
	const { phoneNumbers, visible } = state;
	const { hash } = useLocation();
	const navigate = useNavigate();

	const componentDidUpdate = () => {
		if (hash?.startsWith(`#${Modals.LADDER}`)) {
			setState((prevState) => ({
				...prevState,
				visible: true,
			}));
			API.contact()
				.then(({ data }) => {
					setState((prevState) => ({
						...prevState,
						...data,
						loaded: true,
					}));
				})

				.catch(() => {});
		} else {
			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Modal
			className="bk-modal-banner"
			footer={false}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title={Resources.manageModal.ladderAd}
		>
			{!!phoneNumbers.length ? (
				<>
					<div className="ad">{ladderDescription}</div>
					<ul className="items">
						{phoneNumbers.map(({ number, type }, i) => (
							<li key={i}>
								<Link
									to={`tel:${number}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<Icons.Calling className="icon" />
									<span className="value">{number}</span>
									<span className="text">
										{type === "fax" ? Resources.faxUs : Resources.callUs}
									</span>
								</Link>
							</li>
						))}
					</ul>
				</>
			) : (
				<Spin />
			)}
		</Modal>
	);
};

export default connect((state) => {
	return {
		ladderDescription: state?.settings?.ladderDescription,
	};
})(Component);
